import sizes from '../constants/sizes';

export default {
  scale: window.innerHeight > 720 ? sizes.FULL_HD : sizes.HD,
  mainTransitionDuration: '200ms',
  withAnimation: false,
  mouseIdleTimeout: 10000,
  defaultLang: 'UA',
  gaTrackID: 'UA-120921709-3',
  appVersion: process.env.REACT_APP_VERSION,
  serverTime: null,
  timeDiffFromServer: 0,
};

export const LIST_ITEMS_SIZE = {
  LARGE: {
    width: 355,
    height: 512,
    offset: 3,
    metadataHeight: 140,
    backgroundSize: 'cover',
    horizontalListHeight: 630,
  },
  SMALL: {
    width: 355,
    height: 512,
    offset: 3,
    metadataHeight: 0,
    backgroundSize: 315,
    horizontalListHeight: 630,
  },
  MEDIUM: {
    width: 545,
    height: 306,
    offset: 2,
    metadataHeight: 140,
    backgroundSize: 'cover',
    horizontalListHeight: 460,
  },
  BANNER: {
    width: 1472,
    height: 470,
    offset: 0,
    metadataHeight: 0,
    backgroundSize: 'cover',
    horizontalListHeight: 530,
  },
  SMALL_BANNER: {
    width: 355,
    height: 144,
    offset: 0,
    metadataHeight: 0,
    backgroundSize: 'cover',
    horizontalListHeight: 170,
  },
  FILTERS_BANNER: {
    width: 540,
    height: 318,
    offset: 0,
    metadataHeight: 40,
    backgroundSize: 'cover',
    horizontalListHeight: 252,
  },
  SEARCH: { width: 230, height: 332, offset: 7, metadataHeight: 34, horizontalListHeight: 630 },
  PACKAGE_CONTENT: {
    width: 375,
    height: 355,
    offset: 3,
    metadataHeight: 0,
    backgroundSize: 315,
    horizontalListHeight: 630,
  },
};

export const LIST_ITEMS_BACKGROUND_BY_TYPE = {
  vod: { backgroundSize: 'cover', backgroundPosition: 'center' },
  banner: { backgroundSize: 'cover', backgroundPosition: 'center' },
  small_banner: { backgroundSize: 'cover', backgroundPosition: 'center' },
  channel: { backgroundSize: 'contain', backgroundPosition: 'center' },
  catchup: { backgroundSize: 315, backgroundPosition: 'center 20%' },
  'catchup-large': { backgroundSize: 'contain', backgroundPosition: 'center' },
  'catchup-medium': { backgroundSize: 'cover', backgroundPosition: 'center' },
  'catchup-search': { backgroundSize: 190, backgroundPosition: 'center 20%' },
  filters_banner: { backgroundSize: 'cover', backgroundPosition: 'center' },
};

export const LIST_MAX_SIZE = 20;
export const GRID_MAX_SIZE = 20;

export const LIST_TYPES = {
  SMALL_BANNER: 'SMALL_BANNER',
  FILTERS_BANNER: 'FILTERS_BANNER',
  BANNER: 'BANNER',
  SEARCH: 'SEARCH',
  PACKAGE_CONTENT: 'PACKAGE_CONTENT',
};
// TODO: Solve it another way
export const AVERAGE_LIVE_LATENCY = 50;

export const DEFAULT_PIN = '1234';

export const USER_FLAGS = {
  LIFECELL: 'LIFECELL',
  VOLIA: 'VOLIA',
  DATAGROUP: 'DATAGROUP',
};
